"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var months = [
    {
        name: 'January',
        value: 0
    },
    {
        name: 'Febuary',
        value: 1
    },
    {
        name: 'March',
        value: 2
    },
    {
        name: 'April',
        value: 3
    },
    {
        name: 'May',
        value: 4
    },
    {
        name: 'June',
        value: 5
    },
    {
        name: 'July',
        value: 6
    },
    {
        name: 'August',
        value: 7
    },
    {
        name: 'September',
        value: 8
    },
    {
        name: 'October',
        value: 9
    },
    {
        name: 'November',
        value: 10
    },
    {
        name: 'December',
        value: 11
    }
];
exports.months = months;
//# sourceMappingURL=months.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/months.js
// module id = 890
// module chunks = 0